import { enumObjectTypes, objTypeClassMap } from "../constants";
import { Globals } from "../CoreApp/Globals";
import type { QObjDBObject } from "../CoreApp/QObjDBObject";
import type { QXDoc } from "../CoreApp/QXDoc";

export const GetObjClassForOverride = (overrideObj: QObjDBObject, docRef?: QXDoc) => {
  const objType = (overrideObj.SmartGetFieldValue("objType") || enumObjectTypes.holder) as ValueOf<
    typeof enumObjectTypes
  >;

  const className = objTypeClassMap[objType];
  if (!className) {
    return null;
  }

  const doc: Nullable<QXDoc> = docRef ?? Globals._wsMgr?.GetDoc();
  const objDb = doc?.GetObjDB();
  if (!objDb) {
    return null;
  }

  const objClass = objDb.GetClassByName(className);

  return objClass;
};
